import type {
  MapCoordinateV1,
  PropertyMapConfigurationV1,
} from "@impetusos/contracts"

export const buildMapboxStaticImageUrl = (
  configuration: PropertyMapConfigurationV1,
  center: MapCoordinateV1,
  zoom: number,
): string => {
  const style = configuration.styleUrl.replace("mapbox://styles/", "")
  const url = new URL(
    `https://api.mapbox.com/styles/v1/${style}/static/`
    + `${center.longitude},${center.latitude},${zoom},0/900x500@2x`,
  )
  url.searchParams.set("logo", "true")
  url.searchParams.set("attribution", "true")
  url.searchParams.set("access_token", configuration.publicAccessToken)
  return url.toString()
}
